export enum HarvestProofFormStatus {
  NOT_STARTED = 'NOT_STARTED',
  SMS_SENT = 'SMS_SENT',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  SMS_FAILED = 'SMS_FAILED',
}

export enum HarvestProofParcelStatus {
  PROOF_MISSING = 'PROOF_MISSING',
  PROOF_RECEIVED = 'PROOF_RECEIVED',
}

export const HARVEST_PROOF_FORM_STATUSES = [
  HarvestProofFormStatus.NOT_STARTED,
  HarvestProofFormStatus.SMS_SENT,
  HarvestProofFormStatus.IN_PROGRESS,
  HarvestProofFormStatus.COMPLETE,
  HarvestProofFormStatus.SMS_FAILED,
] as const;
